import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import NavbarLeft from '../Navbar';
import MobileTopBar from '../MobileTopBar/MobileTopBar';
import MobileDrawer from '../MobileDrawer/MobileDrawer';
import { history } from '../../config/store';

const LayoutContent = styled.div`
  @media (max-width: 767.98px) {
    padding-top: 56px;
  }
`;

const Layout = ({ children, user }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleOpenDrawer = () => setIsDrawerOpen(true);
  const handleCloseDrawer = () => setIsDrawerOpen(false);

  return (
    <>
      <MobileTopBar onMenuClick={handleOpenDrawer} />
      <MobileDrawer
        isOpen={isDrawerOpen}
        onClose={handleCloseDrawer}
        history={history}
        role={user?.role}
      />
      <Row noGutters>
        <div className="d-none d-md-block sidebar">
          <NavbarLeft />
        </div>
        <Col md={{ span: 10, offset: 2 }}>
          <LayoutContent>{children}</LayoutContent>
        </Col>
      </Row>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  user: PropTypes.shape({
    role: PropTypes.string
  })
};

Layout.defaultProps = {
  user: null
};

const mapStateToProps = state => {
  const { user } = state.auth;
  return { user };
};

export default connect(mapStateToProps)(Layout);
